export default [
  {
    id: 'stripe',
    allow_reusable_use: true,
    allow_single_use: true,
    compatibility: ['payments', 'subscriptions'],
    currencies: ['USD', 'BRL', 'MXN'],
    description: 'La solución preferida de Piriod para procesar pagos globales. Mejora la experiencia de pago de tus clientes con las soluciones para pagos únicos o recurrentes de Stripe.',
    display: true,
    guide: '/integrations/payments/stripe',
    name: 'Stripe',
    settlement: ['US', 'BR', 'MX'],
    placeholder: '',
    view: 'Stripe',
    warning: '',
    website: 'https://www.stripe.com/'
  },
  {
    id: 'getnet',
    allow_reusable_use: true,
    allow_single_use: true,
    compatibility: ['payments', 'subscriptions'],
    currencies: ['CLP', 'USD'],
    description: 'Procesa pagos con tarjetas de crédito, débito y prepago en Chile y el extranjero. Compatible con cobros únicos y recurrentes, garantiza seguridad y una experiencia fluida para tus clientes.',
    display: true,
    guide: '/integrations/payments/getnet-click',
    name: 'Getnet',
    placeholder: '',
    settlement: ['CL'],
    view: 'Getnet',
    warning: '',
    website: 'https://www.getnet.cl/'
  },
  {
    id: 'getnetclick',
    allow_reusable_use: true,
    allow_single_use: false,
    compatibility: ['payments', 'subscriptions'],
    currencies: ['CLP', 'USD'],
    description: 'Procesa pagos con tarjetas de crédito, débito y prepago en Chile y el extranjero. Compatible con cobros únicos y recurrentes, garantiza seguridad y una experiencia fluida para tus clientes.',
    display: false,
    guide: '/integrations/payments/getnet-click',
    name: 'Getnet Click',
    placeholder: '',
    settlement: ['CL'],
    view: 'Getnet',
    warning: '',
    website: 'https://www.getnet.cl/'
  },
  {
    id: 'paypal',
    allow_reusable_use: false,
    allow_single_use: true,
    compatibility: ['payments'],
    currencies: ['USD', 'MXN'],
    description: 'Permite a los consumidores pagar mediante su billetera digital. Los clientes son redirigidos a la página de pago de PayPal para iniciar sesión y aprobar los cargos. PayPal es ideal para la recaudación de pagos en USD.',
    display: true,
    guide: '/integrations/payments/paypal',
    name: 'PayPal',
    settlement: ['US'],
    placeholder: '',
    view: 'PayPal',
    warning: '',
    website: 'https://developer.paypal.com/home/'
  },
  {
    id: 'oneclick',
    allow_reusable_use: true,
    allow_single_use: false,
    compatibility: ['payments', 'subscriptions'],
    currencies: ['CLP'],
    description: 'Pagos mediante cargos a tarjetas de crédito, débito o prepago emitidas en Chile. Los clientes son redirigidos a la página de pago de OneClick para autorizar sus tarjetas y posteriormente Piriod hace los cargos periódicos.',
    display: true,
    guide: '/integrations/payments/oneclick',
    name: 'Webpay OneClick',
    placeholder: '5970XXXXXXXX',
    settlement: ['CL'],
    view: 'Oneclick',
    warning: 'Tu Código de Comercio debe estar enlazado al Código de Comercio de Piriod (597036088419) en Transbank OneClick.',
    website: 'https://publico.transbank.cl/productos-y-servicios/soluciones-para-ventas-internet/webpay-oneclick'
  },
  {
    id: 'webpay',
    allow_reusable_use: false,
    allow_single_use: true,
    compatibility: ['payments'],
    currencies: ['CLP'],
    description: 'Pagos únicos mediante, tarjetas de crédito, débito o prepago. Los clientes son redirigidos a la página de pago de Webpay para autenticar y ejecutar el pago.',
    display: true,
    guide: '/integrations/payments/webpay-transbank',
    name: 'WebPay',
    placeholder: '5970XXXXXXXX',
    settlement: ['CL'],
    view: 'Webpay',
    warning: 'Tu Código de Comercio debe estar enlazado al Código de Comercio de Piriod (597035838481) en Transbank WebPay.',
    website: 'https://publico.transbank.cl/productos-y-servicios/soluciones-para-ventas-internet/webpay-plus'
  },
  {
    id: 'khipu',
    allow_reusable_use: false,
    allow_single_use: true,
    compatibility: ['payments'],
    currencies: ['CLP'],
    description: 'Pagos directamente mediante transferencia bancaria. Los clientes son redirigidos a la página de pago de Khipu para iniciar sesión y aprobar pagos.',
    display: true,
    guide: '/integrations/payments/khipu',
    name: 'Khipu',
    placeholder: '',
    settlement: ['CL'],
    view: 'Khipu',
    warning: '',
    website: 'https://www.khipu.com/'
  },
  {
    id: 'mercadopago',
    allow_reusable_use: false,
    allow_single_use: true,
    compatibility: ['payments'],
    currencies: ['CLP'],
    description: 'Permite a los consumidores pagar mediante sus tarjetas de crédito. Acepta tarjetas sin pagar gastos fijos a través del líder en procesamiento de pagos para Latinoamérica.',
    display: true,
    guide: '/integrations/payments/mercadopago',
    name: 'Mercado Pago',
    settlement: ['CL'],
    placeholder: '',
    view: 'MercadoPago',
    warning: '',
    website: 'https://www.mercadopago.cl/'
  },
  {
    id: 'twocheckout',
    allow_reusable_use: false,
    allow_single_use: true,
    compatibility: ['payments'],
    currencies: ['USD'],
    description: '2Checkout es la plataforma de monetización todo en uno que te ayuda a maximizar tus ingresos y facilita la recaudación de pagos globales digitales.',
    display: true,
    guide: '/integrations/payments/2checkout',
    name: '2Checkout',
    settlement: ['US'],
    placeholder: '',
    view: 'TwoCheckout',
    warning: '',
    website: 'https://www.2checkout.com/'
  }
]